import BaseController from "./base_controller"
import { t } from "@/utils/i18n"

// Connects to data-controller="entry-navigation"
export default class extends BaseController {
  static values = { 
    newEntryUrl: String,
    editEntryUrl: String,
    entriesUrl: String,
    statisticsUrl: String
  }

  declare newEntryUrlValue: string
  declare editEntryUrlValue: string
  declare entriesUrlValue: string
  declare statisticsUrlValue: string

  connect(): void {
    super.connect()
    this.debug('Entry navigation controller connected')
  }

  // Navigate to new entry form
  navigateToNew(event: MouseEvent): void {
    try {
      event.preventDefault()
      
      const target = event.currentTarget as HTMLElement
      const date = target.dataset.date || (event as any).params?.date
      const url = date ? `${this.newEntryUrlValue}?date=${date}` : this.newEntryUrlValue
      
      this.debug('Navigating to new entry:', url)
      Turbo.visit(url, { action: "replace" })

    } catch (error) {
      this.handleError(error, 'navigateToNew')
      this.showErrorMessage(t('error_load_new_entry'))
    }
  }

  // Navigate to edit entry form
  navigateToEdit(event: MouseEvent): void {
    try {
      event.preventDefault()
      
      const target = event.currentTarget as HTMLElement
      const entryId = target.dataset.entryId || (event as any).params?.entryId
      if (!entryId) {
        throw new Error('Entry ID not found')
      }
      
      const url = this.editEntryUrlValue.replace(':id', entryId)
      
      this.debug('Navigating to edit entry:', url)
      Turbo.visit(url, { action: "replace" })

    } catch (error) {
      this.handleError(error, 'navigateToEdit')
      this.showErrorMessage(t('error_load_edit_entry'))
    }
  }

  // Navigate to entries index
  navigateToEntries(event?: MouseEvent): void {
    try {
      if (event) event.preventDefault()
      
      this.debug('Navigating to entries index:', this.entriesUrlValue)
      Turbo.visit(this.entriesUrlValue, { action: "replace" })
      
    } catch (error) {
      this.handleError(error, 'navigateToEntries')
      this.showErrorMessage(t('error_load_entries'))
    }
  }

  // Navigate to statistics
  navigateToStatistics(event?: MouseEvent): void {
    try {
      if (event) event.preventDefault()
      
      this.debug('Navigating to statistics:', this.statisticsUrlValue)
      Turbo.visit(this.statisticsUrlValue, { action: "replace" })
      
    } catch (error) {
      this.handleError(error, 'navigateToStatistics')
      this.showErrorMessage(t('error_load_statistics'))
    }
  }

  // Quick actions
  quickAddEntry(): void {
    this.navigateToNew({ currentTarget: document.createElement('div'), preventDefault: () => {} } as any)
  }

  quickViewStats(): void {
    this.navigateToStatistics({ preventDefault: () => {} } as any)
  }

  quickViewAllEntries(): void {
    this.navigateToEntries({ preventDefault: () => {} } as any)
  }
}

